// import { useEffect, useState } from "react"
// import { simpleGetter } from "../actions/common"
// import { userApi } from "../api/api"
// import { MainUserWithDemeritsAndSocialTranscriptItems, MainUserWithRoles } from "../types"

// export const useUsersWithSocialScoreAndDemerits = (triggerFetch: number, postUpdate: undefined | ((list: any[]) => void), filters: any): [MainUserWithDemeritsAndSocialTranscriptItems[] | MainUserWithRoles[], boolean, number] => {
//     const [data, setData] = useState([])
//     const [loading, setLoading] = useState(false);
//     const [total, setTotal] = useState(0);

//     const fetchData = async () => {
//         setLoading(true);
//         const response = await simpleGetter(userApi.getUsersWithSocialScoreAndDemerits, filters)
//         setLoading(false);
//         if (response.list) {
//             const finalList = filters.page === 0 ? response.list : [...data, ...response.list]
//             setTotal(response.total)
//             setData(finalList)
//             if (postUpdate) {
//                 postUpdate(finalList);
//             }
//         }
//     }

//     useEffect(() => {
//         fetchData();
//     }, [triggerFetch, filters.page, filters.type, filters.usersWhere?.query])

//     return [data, loading, total];
// }

import { useEffect, useState } from "react";
import { simpleGetter } from "../actions/common";
import { userApi } from "../api/api";
import { MainUserWithDemeritsAndSocialTranscriptItems, MainUserWithRoles } from "../types";

type Filters<T extends "roles" | "demerits"> = {
    page: number;
    type: T;
    usersWhere?: { query?: string };
};

export const useUsersWithSocialScoreAndDemerits = <T extends "roles" | "demerits">(
    triggerFetch: number,
    filters: Filters<T>,
    postUpdate?: ((list: T extends "roles" ? MainUserWithRoles[] : MainUserWithDemeritsAndSocialTranscriptItems[]) => void),
    preventFetch?: boolean
): [T extends "roles" ? MainUserWithRoles[] : MainUserWithDemeritsAndSocialTranscriptItems[], boolean, number] => {
    const [data, setData] = useState<
        T extends "roles" ? MainUserWithRoles[] : MainUserWithDemeritsAndSocialTranscriptItems[]
    >(() => [] as unknown as T extends "roles" ? MainUserWithRoles[] : MainUserWithDemeritsAndSocialTranscriptItems[]);

    const [loading, setLoading] = useState(false);
    const [total, setTotal] = useState(0);

    const fetchData = async () => {
        setLoading(true);
        const response = await simpleGetter(userApi.getUsersWithSocialScoreAndDemerits, filters);
        setLoading(false);
        if (response.list) {
            const finalList = filters.page === 0 ? response.list : [...data, ...response.list];
            setTotal(response.total);
            setData(finalList as any); // Necessary for TS to recognize it properly
            if (postUpdate) {
                (postUpdate as any)(finalList);
            }
        }
    };

    useEffect(() => {
        if (!preventFetch) {
            fetchData();
        }
    }, [triggerFetch, filters.page, filters.type, filters.usersWhere?.query, preventFetch]);

    return [data, loading, total];
};
